import { Ref, ref } from '@vue/composition-api'

import * as localStorage from '@shared/utils/storage/local'
import * as sessionStorage from '@shared/utils/storage/session'

export const useLocalStorage = <T extends any>(
  storageKey: string,
  defaultVal?: T
) => {
  const storageValue = <Ref<T>>ref(localStorage.get<T>(storageKey, defaultVal))

  const setItem = (val: T) => {
    storageValue.value = val
    localStorage.put(storageKey, val)
  }

  const removeItem = () => localStorage.remove(storageKey)

  return {
    value: storageValue,
    setItem,
    removeItem,
  }
}

export const useSessionStorage = <T extends any>(
  storageKey: string,
  defaultVal?: T
) => {
  const storageValue = <Ref<T>>(
    ref(sessionStorage.get<T>(storageKey, defaultVal))
  )

  const setItem = (val: T) => {
    storageValue.value = val
    sessionStorage.put(storageKey, val)
  }

  const removeItem = () => sessionStorage.remove(storageKey)

  return {
    value: storageValue,
    setItem,
    removeItem,
  }
}
